<template>
  <div class="pages">
    <div class="pageContent settingPage">
      <van-form>
        <div class="setting-box">
          <div class="goBack" @click="$router.back()">
            <img src="@/assets/img/goBack_btn_black.svg" alt="" />
          </div>
          <div class="menu-box">
            <div class="menu-item">{{ $t3('原密码', 'Original password') }}
              <van-field type="password" v-model="form.password" :placeholder="$t('form.label.enter')" />
            </div>
            <div class="menu-item">{{ $t3('新密码', 'New password') }}
              <van-field type="password" v-model="form.newPassword" :placeholder="$t('form.label.enter')" />
            </div>
            <div class="menu-item">{{ $t3('确认新密码', 'Confirm New password') }}
              <van-field type="password" v-model="form.rePassword" :placeholder="$t('form.label.enter')" />
            </div>
          </div>
        </div>
        <div class="setting-btn" @click="submit">{{ $t3('提交', 'Submit') }}</div>
      </van-form>
    </div>
  </div>
</template>
  
<script>

import { passwordGuest, passwordMedia, passwordWorker, passwordGuangzhou } from '@/api/login'
import { mapGetters } from 'vuex'

const tmpForm = {
  conferenceId: undefined,
  userId: undefined,
  password: undefined,
  newPassword: undefined,
  rePassword: undefined
}

export default {
  name: 'changePassword',
  data() {
    return {
      form: {},
      rules: {
        password: [{ msg: ['原密码不能为空', ''] }],
        newPassword: [{ msg: ['新密码不能为空', ''] }],
        rePassword: [{ msg: ['请再次输入新密码', ''] }],
      },
      type: this.$route.params.type
    }
  },
  computed: {
    ...mapGetters(['userId'])
  },
  created() {
    this.form = Object.assign({}, tmpForm)
  },
  methods: {
    submit() {
      console.log('?')
      this.$validateI18n(this.form, this.rules).then(() => {
        console.log('??')
        if (this.form.newPassword !== this.form.rePassword) {
          this.$notify('两次输入的密码不一致')
        } else {
          console.log('???')
          this.form.userId = this.userId
          this.form.conferenceId = this.$route.params.conferenceId
          if (this.type === 'GT') {
            passwordGuest(this.form).then(() => {
              this.$router.push('login')
            })
          } else if (this.type === 'MT') {
            passwordMedia(this.form).then(() => {
              this.$router.push('login')
            })
          } else if (this.type === 'WK') {
            passwordWorker(this.form).then(() => {
              this.$router.push('login')
            })
          } else if (this.type === 'GZ') {
            passwordGuangzhou(this.form).then(() => {
              this.$router.push('login')
            })
          }
        }
      })
    }
  }
}
</script>
  
<style lang="scss" scoped>
.setting-box {
  background: #FFF;
}
</style>